import React, { Suspense, memo } from "react";
import { BrowserRouter, useRoutes, RouteObject } from "react-router-dom";

import MyRoute from "@src/routes/MyRoute";
import RouteScrollToTop from "@src/routes/RouteScrollToTop";
import myRoutes from "@src/routes/MyRoutes";
import NotFound from "@src/views/components/auth/NotFound";
import NotAllowed from "@src/views/components/auth/NotAllowed";
import Loading from "@src/views/components/general/Loading";
import { Route } from "@src/redux/index"; // Import the Route type

const getRoute = (route: Route): RouteObject => {
  if (route.children) {
    return {
      path: route.path,
      element: (
        <MyRoute
          name={route.name}
          authenticate={route.authenticate || false}
          accessKey={route.key || undefined}
        >
          {route.component}
        </MyRoute>
      ),
      children: route.children.map(getRoute),
    };
  } else {
    return {
      path: route.path,
      element: (
        <MyRoute
          name={route.name}
          authenticate={route.authenticate || false}
          accessKey={route.key || undefined}
        >
          {route.component}
        </MyRoute>
      ),
    };
  }
};

const MyRouter = () => {
  const routes: RouteObject[] = [
    ...myRoutes.map(getRoute),
    { path: "*", element: <NotFound /> },
    { path: "not-allowed", element: <NotAllowed /> },
  ];

  return useRoutes(routes);
};

export const Router = memo(() => (
  <BrowserRouter>
    <Suspense fallback={<Loading />}>
      <RouteScrollToTop />
      <MyRouter />
    </Suspense>
  </BrowserRouter>
));
